import { useEffect, useState } from 'react';

/**
 * Returns true when the viewport is narrower than `breakpoint` px (default 640,
 * matching Tailwind's `sm`). Used to switch UI to mobile-friendly variants —
 * e.g. opening react-datepicker calendars as a centered portal instead of an
 * edge-anchored popper that can overflow the screen.
 */
export function useIsMobile(breakpoint = 640): boolean {
  const query = `(max-width: ${breakpoint - 0.02}px)`;
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMobile;
}
